import { RecordsDataCollection } from 'modules/finance/components/Budgets/ExpenseBudgetDetailDataCollection/RecordsDataCollection'

import { useExpenseBudgetDetailContext } from 'modules/finance/pages/ExpenseBudgetDetailPage'

const RecordsTab = () => {
  const { budget, locale } = useExpenseBudgetDetailContext()
  return <RecordsDataCollection budget={budget} locale={locale} />
}

export default RecordsTab
